import React from "react";

export const Button = ({ 
  children, 
  variant = "primary", 
  size = "md", 
  icon,
  className = "",
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-grigora-500 hover:bg-grigora-600 text-white focus:ring-grigora-500",
    secondary: "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-200",
    ghost: "bg-transparent hover:bg-gray-100 text-gray-600 focus:ring-gray-200",
    danger: "bg-red-50 hover:bg-red-100 text-red-600 focus:ring-red-200"
  };

  const sizes = {
    sm: "h-8 px-3 text-xs",
    md: "h-10 px-4 text-sm",
    lg: "h-12 px-6 text-base",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {icon && <span className="material-icons-outlined text-lg mr-2">{icon}</span>}
      {children}
    </button>
  );
};

